import React from 'react';
import { Link, withRouter } from 'react-router';
import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';

import IdleTimeout from '../IdleTimeout';
import ImpersonatorBanner from '../ImpersonatorBanner';
import Footer from '../../components/Footer';
import Message from '../../components/Message';
import Nav from '../../components/Nav';
import SiteHeader from '../../components/SiteHeader';
import InProdNotifications from '../InProdNotifications';
import SidebarWrapper from '../../components/SidebarWrapper';
import InlineManual from '../InlineManual';
import FeatureEnabled from '../../components/FeatureEnabled';
import * as constants from '../Authorization/constants';
import intersectLogo from './intersect-rgb-gray-teal.png';
import './styles.css';

class AppWithoutServerlessCounselorCommunity extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    idleTimeout: PropTypes.number,
    current: PropTypes.shape({
      viewer: PropTypes.shape({
        isAuthenticated: PropTypes.bool,
      }),
    }),
    router: PropTypes.shape({
      location: PropTypes.object.isRequired,
      listen: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    announcementSidebarVisible: false,
    announcement: {},
    hasError: false,
  };

  componentDidMount() {
    this.routerListener = this.props.router.listen(() => this.setState({ hasError: false }));
  }

  componentWillUnmount() {
    this.routerListener();
  }

  componentDidCatch(error, errorInfo) {
    /* istanbul ignore next else */
    if (process.env.NODE_ENV !== 'production') console.error(error, errorInfo); // eslint-disable-line no-console
    this.setState({ hasError: true });
    if (window.Sentry) {
      window.Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        window.Sentry.captureException(error);
      });
    }
  }

  handleButtonClick = (readmoreData) => {
    this.setState((prevState) => ({ announcement: readmoreData, announcementSidebarVisible: !prevState.announcementSidebarVisible }));
  };

  closeNotificationBar = () => {
    /* istanbul ignore if */
    if (this.state.announcementSidebarVisible) {
      this.setState({ announcementSidebarVisible: false });
    }
  };

  render() {
    const { children, idleTimeout, current } = this.props;
    const { announcementSidebarVisible, announcement, hasError } = this.state;
    const isAuthenticated = get(current, 'viewer.isAuthenticated') || false;

    return (
      <div tabIndex="0">
        {isAuthenticated && (
          <a
            className="ui button secondary"
            styleName="skipToMainContent"
            href="#content"
            aria-label="Skip to main content"
          >
            Jump to main content
          </a>
        )}
        <SidebarWrapper.Content notPaddedDimmed onClick={this.closeNotificationBar}>
          {!isAuthenticated && (
            <div styleName="wrapper">
              <div styleName="main">
                <header styleName="header">
                  <SiteHeader />
                </header>
                <div styleName="content">
                  {hasError ? <Message error header="Oops, something went wrong" /> : children}
                </div>
                <footer styleName="footer">
                  <Footer />
                </footer>
              </div>
            </div>
          )}
          {isAuthenticated && (
            <React.Fragment>
              <IdleTimeout timeout={(idleTimeout || 1800) * 1000} />
              <div styleName="wrapper">
                <div styleName="main">
                  <InProdNotifications onReadMoreClick={this.handleButtonClick} onContentClick={this.handleButtonClick} />
                  <ImpersonatorBanner />
                  <header styleName="headerNav">
                    <nav styleName="leftAlign">
                      <Link styleName="logo" to="/">
                        <img
                          src={intersectLogo}
                          styleName="verticalAlign"
                          alt="Intersect by PowerSchool Logo"
                        />
                      </Link>
                      <Nav className="hidden-mobile hidden-tablet print" styleName="print" />
                    </nav>
                    <SiteHeader />
                  </header>
                  <div styleName="content">
                    {hasError ? <Message error header="Oops, something went wrong" /> : children}
                  </div>
                  <footer styleName="footer">
                    <Footer />
                  </footer>
                </div>
              </div>
              <FeatureEnabled allOf={constants.INLINE_MANUAL}>
                <InlineManual />
              </FeatureEnabled>
            </React.Fragment>
          )}
        </SidebarWrapper.Content>
        <SidebarWrapper.Bar
          visible={announcementSidebarVisible}
          onClose={this.closeNotificationBar}
          styleName="padded-content"
        >
          <div styleName="announcement">
            <div styleName="announcement-header">Product Announcement</div>
            <div styleName="announcement-title">
              {announcement.title}
              {announcement.createdDate && (
                <span styleName="announcement-date">
                  <FormattedDate value={announcement.createdDate} month="short" day="2-digit" />
                </span>
              )}
            </div>
            <div styleName="announcement-content">{announcement.content}</div>
          </div>
        </SidebarWrapper.Bar>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect((state) => ({ current: state.current })),
)(AppWithoutServerlessCounselorCommunity);
